import { type CalendarItem } from '../types'

/** What a dragged chip or bar carries with it. */
export type CalendarDragData = {
  item: CalendarItem
  /** The moment a piece of content belongs to, when it is on screen. */
  parent?: CalendarItem
}

const KEY = 'calendarDrag'

export const toDragData = (
  data: CalendarDragData
): Record<string, unknown> => ({
  [KEY]: data,
})

/**
 * Reads the calendar's own payload off a drag. Everything else being dragged
 * across the page — a swimlane, a block, a file — reads as nothing here.
 */
export const readDragData = (
  data: Record<string | symbol, unknown>
): CalendarDragData | null => {
  const value = data[KEY]
  if (value === null || typeof value !== 'object') return null
  return 'item' in value ? (value as CalendarDragData) : null
}
